<template>
    <div>
    <QueryFrame :count="count" @handlePage="handlePage" @handlePageSize="handlePageSize">
      <div slot="queryParams">
        <div class="queryContainer">
          <div class="queryItem">
            <label>药店商品编码:</label>
            <lk-input :maxlength="100" placeholder="请输入药店商品编码" class="item" clearable v-model.trim="query.fixmedinsHilistId"></lk-input>
          </div>
          <div class="queryItem">
            <label>中心商品编码:</label>
            <lk-input :maxlength="100" placeholder="请输入中心商品编码" class="item" clearable v-model.trim="query.medListCodg"></lk-input>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type="primary" @click="handleSearch">查询</lk-button>
            <lk-button @click="handleReset">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <lk-table border :columns="columns" :data="tableData"></lk-table>
      </div>
    </QueryFrame>
  </div>
</template>
<script>
import QueryFrame from '../../../components/frame/QueryFrame.vue';
import utils from '../../../libs/utils';
import mapState from '../../../mixins/mapState'; // 鉴权
import queryMixins from '../../../mixins/queryMixins';
import insurance from '../../../services/insuranceLanzhou';

export default {
  name: 'CatalogMatching',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
  },
  computed: {},
  data() {
    return {
      query: {
        fixmedinsHilistId: '',
        medListCodg: '',
      },
      columns: [
        {
          title: '药店商品编码',
          key: 'fixmedinsHilistId',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '中心商品编码',
          key: 'medListCodg',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '药店通用名称',
          key: 'fixmedinsHilistName',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '中心通用名称',
          key: 'fixmedinsHilistName',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '药店规格',
          key: 'spec',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '中心规格',
          key: 'spec',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '药店剂型',
          key: 'dosform',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '中心剂型',
          key: 'dosageForm',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '药店生产厂家',
          key: 'producerName',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '中心生产单位',
          key: 'producerName',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '药店批准文号',
          key: 'aprvno',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '中心批准文号',
          key: 'aprvno',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '操作',
          minWidth: 60,
          fixed: 'right',
          render: (h, params) => {
            return h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  const param = {};
                  param.fixmedinsHilistId = params.row.fixmedinsHilistId || '';
                  param.listType = params.row.listType || '';
                  param.medListCodg = params.row.medListCodg || '';
                  this.delete(param);
                  this.tableData.splice(params.index, 1);
                },
              },
            }, '撤销对照关系');
          },
        },
      ],
      count: 0,
      tableData: [],
    };
  },
  methods: {
    handleReset() {
      this.query.fixmedinsHilistId = '';
      this.query.medListCodg = '';
      this.page = 1;
      this.size = 20;
    },
    delete(params) {
      insurance.dirCancel(params).then((res) => {
        if (res.data.status === 200) {
          this.$Message.success('撤销成功');
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getData() {
      this.params.page = this.page;
      this.params.size = this.size;
      insurance.getDireMatch(this.params).then((res) => {
        if (res.data.status === 200) {
          const data = res.data.data.list;
          this.count = res.data.data.count;
          this.tableData = data;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  created() {
    this.handleSearch(true);
  },
};
</script>
<style lang="less" scoped>
</style>
